<template>
  <Tooltip2Vue
    :hover="showTooltip"
    :position="position"
    :deleteTooltip="!showTooltip"
    class="tooltip-avatars"
  >
    <vs-avatar-group>
      <vs-avatar
        style="z-index: 1"
        v-for="(item, index) in visibleAvatars"
        :key="`avatar-${index}-${item.id || item.name || index}`"
        size="35"
        class="lego-vs-avatar"
        :color="getAvatarColor(item.id || index)"
        v-b-tooltip.hover="index < max"
        :title="index < max ? item.name : ''"
        @mouseover="
          index === max && item.name === '+' ? handleShowTooltip(true) : null
        "
        @mouseleave="
          index === max && item.name === '+' ? handleShowTooltip(false) : null
        "
      >
        <template #text>
          {{ item.name === "+" ? `+${hiddenAvatars.length}` : item.name || "" }}
        </template>
      </vs-avatar>
    </vs-avatar-group>
    <template #tooltip>
      <div
        v-for="item in hiddenAvatars"
        :key="`hidden-${item.id || item.name}`"
        class="d-flex align-items-center p-2"
        style="gap: 0.5rem"
      >
        <i class="fas fa-user"></i>
        <span>{{ item.name }} </span>
      </div>
    </template>
  </Tooltip2Vue>
</template>

<script>
import Tooltip2Vue from "@/components/Tooltip2Vue/Tooltip2Vue.vue";
import { avatarColors } from "../../utils/avatarColors";
export default {
  props: {
    listAvatars: {
      type: Array,
      required: true,
      default: () => [],
    },
    position: {
      type: String,
      required: false,
      default: "right",
    },
    max: {
      type: Number,
      required: false,
      default: 5,
    },
  },
  components: {
    Tooltip2Vue,
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  methods: {
    getAvatarColor(idx) {
      return avatarColors(idx);
    },
    handleShowTooltip(bool) {
      this.showTooltip = bool;
    },
  },
  computed: {
    visibleAvatars() {
      if (!this.listAvatars || this.listAvatars.length === 0) {
        return [];
      }

      // Si hay menos o igual a max elementos, mostrar todos
      if (this.listAvatars.length <= this.max) {
        return this.listAvatars;
      }

      // Si hay más de max elementos, mostrar max elementos + el botón "+"
      return [
        ...this.listAvatars.slice(0, this.max),
        { name: "+", id: "plus-button" },
      ];
    },
    hiddenAvatars() {
      if (!this.listAvatars || this.listAvatars.length <= this.max) {
        return [];
      }
      // Mostrar los elementos que están después del max
      return this.listAvatars.slice(this.max);
    },
  },
  watch: {
    listAvatars: {
      handler() {
        // Forzar re-render cuando cambia la lista
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
